// Email validation utility with disposable domain blocking

const DISPOSABLE_EMAIL_DOMAINS = [
  '10minutemail.com',
  '10minutemail.net',
  'guerrillamail.com',
  'guerrillamail.net',
  'guerrillamail.biz',
  'guerrillamail.org',
  'mailinator.com',
  'tempmail.com',
  'temp-mail.org',
  'temp-mail.io',
  'throwaway.email',
  'getnada.com',
  'yopmail.com',
  'maildrop.cc',
  'trashmail.com',
  'fakeinbox.com',
  'sharklasers.com',
  'spam4.me',
  'grr.la',
  'dispostable.com',
  'mohmal.com',
  'getairmail.com',
  'emkei.cz',
  'mytemp.email',
  '33mail.com',
  'emailondeck.com',
  'tempmailaddress.com',
  'mailnesia.com',
  'mintemail.com'
];

/**
 * Validates email format using regex
 */
export const validateEmailPattern = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

/**
 * Extracts domain from email address
 */
export const extractDomain = (email) => {
  const parts = email.toLowerCase().split('@');
  return parts.length === 2 ? parts[1] : '';
};

/**
 * Checks if email uses a disposable domain
 */
export const isDisposableEmail = (email) => {
  const domain = extractDomain(email);
  return DISPOSABLE_EMAIL_DOMAINS.includes(domain);
};

/**
 * Complete email validation
 * Returns { valid: boolean, error: string }
 */
export const validateEmail = (email) => {
  if (!email || email.trim() === '') {
    return {
      valid: false,
      error: 'Email is required'
    };
  }

  if (!validateEmailPattern(email)) {
    return {
      valid: false,
      error: 'Please enter a valid email address'
    };
  }

  if (isDisposableEmail(email)) {
    return {
      valid: false,
      error: 'Disposable email addresses are not allowed. Please use a permanent email address.'
    };
  }

  return {
    valid: true,
    error: ''
  };
};
